import { PixiSettings } from "./pixiSettings";
import { Settings } from "./settings";

/**
 * Centralized texture configuration system for responsive components
 * Configuration objects are used with getResponsiveConfig from DimensionsContext
 */

// Centralized font family configuration
export const FONT_CONFIG = {
  PRIMARY:
    Settings.APP.UI_THEME === "secondary"
      ? '"Oxanium", sans-serif'
      : '"Noto Sans", sans-serif',
  SECONDARY: "Arial", // Fallback/secondary font if needed
};

// Centralized text styling configuration
export const TEXT_STYLE_CONFIG = {
  // Outline properties for text elements
  OUTLINE: {
    stroke: "rgba(0, 0, 0, 0.2)", // Black outline with 0.2 opacity
    strokeThickness: 1, // Outline thickness in pixels
  },
};

// Shared toolbar buttons configuration (Home, Fullscreen, Sound, Menu)
export const TOOLBAR_BUTTON_CONFIG = {
  BASE_WIDTH: 36,
  BASE_HEIGHT: 36,

  DEVICE_CONFIGS: {
    [PixiSettings.DEVICE.MOBILE]: {
      [PixiSettings.ORIENTATION.PORTRAIT]: {
        deviceMultiplier: 1.4,
      },
      [PixiSettings.ORIENTATION.LANDSCAPE]: {
        deviceMultiplier: 1.25,
      },
    },
    [PixiSettings.DEVICE.TABLET]: {
      [PixiSettings.ORIENTATION.PORTRAIT]: {
        deviceMultiplier: 1.35,
      },
      [PixiSettings.ORIENTATION.LANDSCAPE]: {
        deviceMultiplier: 1.25,
      },
    },
    [PixiSettings.DEVICE.DESKTOP]: {
      deviceMultiplier: 1.0,
    },
  },
};

// Primary UI top toolbar buttons (Fullscreen, etc.) - copy of TOOLBAR_BUTTON_CONFIG, modify multipliers to tune size
export const PRIMARY_USER_INTERFACE_BUTTON_CONFIG = {
  BASE_WIDTH: 36,
  BASE_HEIGHT: 36,

  DEVICE_CONFIGS: {
    [PixiSettings.DEVICE.MOBILE]: {
      [PixiSettings.ORIENTATION.PORTRAIT]: {
        deviceMultiplier: 1.85,
      },
      [PixiSettings.ORIENTATION.LANDSCAPE]: {
        deviceMultiplier: 1.65,
      },
    },
    [PixiSettings.DEVICE.TABLET]: {
      [PixiSettings.ORIENTATION.PORTRAIT]: {
        deviceMultiplier: 2.3,
      },
      [PixiSettings.ORIENTATION.LANDSCAPE]: {
        deviceMultiplier: 1.75,
      },
    },
    [PixiSettings.DEVICE.DESKTOP]: {
      deviceMultiplier: 1.1,
    },
  },
};

// Sound button configuration
export const USER_INTERFACE_BUTTON_CONFIG = {
  BASE_WIDTH: 58,
  BASE_HEIGHT: 58,

  // 45,38,60,45,58

  DEVICE_CONFIGS: {
    [PixiSettings.DEVICE.MOBILE]: {
      [PixiSettings.ORIENTATION.PORTRAIT]: {
        deviceMultiplier: 2.05,
      },
      [PixiSettings.ORIENTATION.LANDSCAPE]: {
        deviceMultiplier: 1.6,
      },
    },
    [PixiSettings.DEVICE.TABLET]: {
      [PixiSettings.ORIENTATION.PORTRAIT]: {
        deviceMultiplier: 2.225,
      },
      [PixiSettings.ORIENTATION.LANDSCAPE]: {
        deviceMultiplier: 1.6,
      },
    },
    [PixiSettings.DEVICE.DESKTOP]: {
      deviceMultiplier: 1.0,
    },
  },
};

